/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import SuggestionDescriptor, { ISuggestion, ISuggestionJSON } from '../descriptors/suggestiondescriptor';

export interface IConnectResponse extends IMessage {
	channel: string;
	suggestions?: string[];
	suggestionsV2?: ISuggestionJSON[];
}

export default class ConnectResponse extends Message {
	public readonly suggestions: ISuggestion[];

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesConnectResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			channel: {
				type: 'string',
				id: 1
			},
			suggestions: {
				type: 'string',
				rule: 'repeated',
				id: 2
			},
			suggestionsV2: {
				type: 'SuggestionDescriptor',
				rule: 'repeated',
				id: 3
			}
		}
	};

	public constructor(
		public readonly channel: string,
		private readonly _suggestions?: ISuggestion[],
		private readonly _suggestionsV2?: ISuggestion[]
	) {
		super();

		this.suggestions = _suggestionsV2?.length ? _suggestionsV2! : _suggestions!;
	}

	public toJSON(): IConnectResponse {
		return {
			channel: this.channel,
			suggestions: this._suggestions?.map( suggestion => JSON.stringify( suggestion ) ),
			suggestionsV2: this._suggestionsV2?.map( SuggestionDescriptor.toJSON )
		};
	}

	public static fromJSON( object: IConnectResponse ): ConnectResponse {
		return new ConnectResponse(
			object.channel,
			object.suggestions?.map( suggestion => JSON.parse( suggestion ) ),
			object.suggestionsV2?.map( SuggestionDescriptor.fromJSON )
		);
	}
}
